import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import SessionFacade from '@app/core/facades/session.facade';
import StudentFacade from '@app/core/facades/student.facade';
import VersionFacade from '@app/core/facades/version.facade';
import { Widget } from '@app/core/models/enumerations/widget.enum';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterComponentRefInterface } from '@app/shared/filters/filter-componentRef.interface';

import FilterSetChange from '@app/shared/filters/filter-set-change.model';
import FilterDirective from '@app/shared/filters/filter.directive';
import FilterMap from '@app/shared/filters/filter.map';
import Filter from '@app/shared/filters/filter.model';

import SubHeaderWidgetsState from '@app/shared/states/sub-header-widgets.state';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-sub-header',
  styleUrls: ['./sub-header.component.scss'],
  templateUrl: './sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubHeaderComponent {
  private readonly _filterValue = new BehaviorSubject<FilterSetChange>(new FilterSetChange());
  @ViewChild(FilterDirective, { static: true }) public filterHost: FilterDirective;
  public sessionFiltered$ = this._session.sessionFiltered$;
  @Input() public showHeader = false;
  @Input() public title: string;
  @Input() public icon: string;
  @Input() public widgetType: Widget = Widget.LeaderboardToggle;
  @Input() public showAllSubjects: boolean;

  constructor(
    private readonly _componentFactory: ComponentFactoryResolver,
    private readonly _widgetsState: SubHeaderWidgetsState,
    private readonly _session: SessionFacade,
    private readonly _version: VersionFacade,
    private readonly _student: StudentFacade
  ) {}

  private _filters: Filter[];

  @Input() get filters(): Filter[] {
    return this._filters;
  }

  set filters(filters: Filter[]) {
    const hasStudentFilter = filters?.find((item) => item === FilterType.Student);
    this._student.setStudentFilter(!!hasStudentFilter);
    this._filters = filters;
    this.filterHost.viewContainerRef.clear();
    this._filters?.forEach((filter) => {
      const componentFactory = this._componentFactory.resolveComponentFactory(FilterMap.get(filter.componentId));
      const component: ComponentRef<FilterComponentRefInterface> =
        this.filterHost.viewContainerRef.createComponent(componentFactory);
      component.instance.config = {
        ...filter.config,
        showAllSubjects: this.showAllSubjects,
        isStudentOrGuide: filter === FilterType.Student || filter === FilterType.GuidesPerLevel ? true : null,
      };
      component.instance.valueChange?.subscribe((value: FilterChange) => {
        this._filterValue.next(new FilterSetChange([...this._filterValue.value.filters, value]));
        this._version.detectChanges();
      });
    });
  }

  get widgets(): TemplateRef<SubHeaderWidgetsState> | null {
    return this._widgetsState.get(this.widgetType) || null;
  }
}
